import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import apiInstance from '../../../../../Utils/api'
import { FiChevronRight } from 'react-icons/fi'
import BranchButton from '../../branch/shared/BranchButton'
import BranchSelect from '../../branch/shared/BranchSelect'
import BranchImageUploader from '../../branch/shared/BranchImageUploader'
import '../../branch/branch.css'
import '../staff.css'

export default function StaffUpdate() {
  const navigate = useNavigate()
  const location = useLocation()
  const ID = location.pathname.split('/')[2]
  const [name, setName] = useState('')
  const [title, setTitle] = useState('Dr.')
  const [role, setRole] = useState('Doctor')
  const [qualifications, setQualifications] = useState([''])
  const [specialties, setSpecialties] = useState([''])
  const [biography, setBiography] = useState('')
  const [newImages, setNewImages] = useState([])
  const [existingImageUrl, setExistingImageUrl] = useState('')
  const [loading, setLoading] = useState(false)

  const handleArrayChange = (index, value, arr, setter) => {
    const updated = [...arr]
    updated[index] = value
    setter(updated)
  }

  const addArrayItem = (arr, setter) => {
    setter([...arr, ''])
  }

  const removeArrayItem = (index, arr, setter) => {
    if (arr.length > 1) {
      setter(arr.filter((_, i) => i !== index))
    }
  }

  const update = async () => {
    if (!name) {
      Swal.fire({ title: 'Name is required!', icon: 'error', showConfirmButton: false, timer: 2000 })
      return
    }

    setLoading(true)
    const formData = new FormData()
    formData.append('name', name)
    formData.append('title', title)
    formData.append('role', role)
    qualifications.filter(q => q.trim()).forEach(q => formData.append('qualifications[]', q))
    specialties.filter(s => s.trim()).forEach(s => formData.append('specialties[]', s))
    if (biography) formData.append('biography', biography)
    if (newImages[0]) formData.append('image', newImages[0])

    try {
      await apiInstance.put('staff/' + ID, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      Swal.fire({ title: 'Successful!', text: 'Staff updated successfully!', icon: 'success', showConfirmButton: false, timer: 1500 })
      navigate('/staff')
    } catch (err) {
      setLoading(false)
      Swal.fire({
        title: 'Something Wrong!',
        text: err.response?.data?.message || 'Try again, Please.',
        icon: 'warning',
        showConfirmButton: false,
        timer: 2000
      })
    }
  }

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await apiInstance.get('staff/' + ID)
        const data = res.data.data
        setName(data.name || '')
        setTitle(data.title || 'Dr.')
        setRole(data.role || 'Doctor')
        setQualifications(data.qualifications?.length > 0 ? data.qualifications : [''])
        setSpecialties(data.specialties?.length > 0 ? data.specialties : [''])
        setBiography(data.biography || '')
        if (data.imageUrl) setExistingImageUrl(data.imageUrl)
      } catch (err) {
        console.error(err)
      }
    }
    fetchDetail()
  }, [ID])

  const renderArrayField = (label, arr, setter, placeholder) => (
    <div className='branch-field'>
      <label className='branch-field-label'>{label}</label>
      {arr.map((item, index) => (
        <div key={index} className='branch-phone-group'>
          <input
            type='text'
            className='branch-input'
            placeholder={placeholder}
            value={item}
            onChange={(e) => handleArrayChange(index, e.target.value, arr, setter)}
          />
          {arr.length > 1 && (
            <button type='button' className='branch-phone-remove' onClick={() => removeArrayItem(index, arr, setter)}>✕</button>
          )}
        </div>
      ))}
      <BranchButton variant='outline' className='branch-phone-add' onClick={() => addArrayItem(arr, setter)}>+ Add</BranchButton>
    </div>
  )

  return (
    <div className='branch-page'>
      <div className='branch-breadcrumb'>
        <Link to='/staff'>Staff</Link>
        <FiChevronRight className='separator' size={14} />
        <span className='current'>Update Staff</span>
      </div>
      <div className='branch-page-title'>Update Staff</div>
      <div className='branch-page-subtitle'>Edit staff profile details</div>

      <div className='branch-card'>
        <div className='branch-card-body'>
          <div className='branch-form-grid'>
            <div>
              <div className='branch-form-section'>
                <div className='branch-form-section-title'>General Information</div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Title</label>
                  <input type='text' className='branch-input' placeholder='e.g. Dr.' value={title} onChange={(e) => setTitle(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Name <span className='required'>*</span></label>
                  <input type='text' className='branch-input' placeholder='Full name' value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Role</label>
                  <BranchSelect
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    options={[
                      { value: 'Doctor', label: 'Doctor' },
                      { value: 'Founder', label: 'Founder' },
                      { value: 'Both', label: 'Both' }
                    ]}
                  />
                </div>
                {renderArrayField('Qualifications', qualifications, setQualifications, 'e.g. M.B.,B.S')}
                {renderArrayField('Specialties', specialties, setSpecialties, 'e.g. Cardiology')}
              </div>
            </div>
            <div>
              <div className='branch-form-section'>
                <div className='branch-form-section-title'>Profile</div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Biography</label>
                  <textarea className='branch-input' rows={5} placeholder='Write biography...' value={biography} onChange={(e) => setBiography(e.target.value)} />
                </div>
                <div className='branch-field'>
                  <label className='branch-field-label'>Profile Image</label>
                  <BranchImageUploader
                    files={newImages}
                    existingUrls={existingImageUrl ? [existingImageUrl] : []}
                    onAdd={(newFiles) => { setNewImages(newFiles); setExistingImageUrl('') }}
                    onRemove={(idx) => setNewImages(prev => prev.filter((_, i) => i !== idx))}
                    onRemoveExisting={() => setExistingImageUrl('')}
                    multiple={false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='branch-form-footer'>
            <BranchButton variant='outline' to='/staff'>Cancel</BranchButton>
            <BranchButton onClick={update} loading={loading}>Save Changes</BranchButton>
          </div>
        </div>
      </div>
    </div>
  )
}
